import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllRoles } from "../../../../store/slices/Roles/rolesSlice";

const useCreateRoleModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roleState = useSelector((state) => state.roles);

  useEffect(() => {
    if (roleState?.allRoles?.length === 0) {
      dispatch(getAllRoles());
    }
    // eslint-disable-next-line
  }, []);

  const handleRoleClick = (item) => {
    if (item) {
      navigate({
        pathname: "/configure/role/permission",
        search: `role=${item._id}`,
      });
    } else {
      navigate("/configure/role/permission");
    }
  };

  return {
    roleState,
    handleRoleClick,
  };
};

export default useCreateRoleModal;
